import React from "react";
import About from "./pages/About";
import CKD from "./pages/CKD";
import Providers from "./pages/Providers";
import NewPatients from "./pages/NewPatients";
import EstPatients from "./pages/EstPatients";
import Insurances from "./pages/Insurances";
import Forms from "./pages/Forms";
import Educational from "./pages/Educational";
import Billing from "./pages/Billing";
import Locations from "./pages/Locations"
import Contact from "./pages/Contact";
import Email from "./pages/Email";
import styled from "styled-components";
// TODO: use navigation
// import { BrowserRouter, Route, Link } from "react-router-dom";

const StyledPane = styled.div`

  /* Default layout for screens smaller than 768px */
    padding: 20px;
    margin-top: 10px;
  /* Apply grid layout for screens 768px and wider */
  @media (min-width: 768px) {
    padding: 40px;
    margin-top: 110px;
  }

  
  background: linear-gradient(#f0f5fa, #c1def4);
  margin-bottom: 20px;
`;

const RightPane = ({ page }) => {
  return (

    <StyledPane>
      {page === "about" ? <About /> : null}
      {page === "ckd" ? <CKD /> : null}
      {page === "providers" ? <Providers /> : null}
      {page === "newpts" ? <NewPatients /> : null}
      {page === "estpts" ? <EstPatients /> : null}
      {page === "insurances" ? <Insurances /> : null}
      {page === "forms" ? <Forms /> : null}
      {page === "educational" ? <Educational /> : null}
      {page === "billing" ? <Billing /> : null}
      {page === "locations" ? <Locations /> : null}
      {page === "contact" ? <Contact /> : null}
      {page === "email" ? <Email /> : null}
    </StyledPane>

  );
};

export default RightPane;
